export default [
	{
		columnName: 'id',
		columnDisplayName: 'Id',
		display: false
	},
	{
		columnName: 'location',
		columnDisplayName: 'Location',
		display: true
	},
	{
		columnName: 'departments',
		columnDisplayName: 'Departments',
		display: true
	},
	{
		columnName: 'address',
		columnDisplayName: 'Primary Address',
		display: true
	},
	{
		columnName: 'city',
		columnDisplayName: 'City',
		display: true
	},
	{
		columnName: 'state',
		columnDisplayName: 'State',
		display: true
	},
	{
		columnName: 'zip',
		columnDisplayName: 'Zip',
		display: true
	},
	{
		columnName: 'phone',
		columnDisplayName: 'Primary Phone',
		display: true
	},
	{
		columnName: 'active',
		columnDisplayName: 'Active',
		display: true,
		slot: 'activeCheckbox'
	},
	{
		columnName: 'delete',
		columnDisplayName: '',
		display: true,
		slot: 'deleteAction'
	}
];
